import { Dropdown } from "antd";
import React from "react";
import CustomLabel from "../../../customLabel";
import "../../styles.scss";

const CustomDropdown = ({
  children,
  customClass,
  disabled,
  onBlur,
  overlay,
  dropdownVisible,
  id,
  required,
  setParentState,
  style,
  title,
  uuid,
}) => {
  const onVisibleChange = (visible) => {
    if (!visible) {
      const menu = document.getElementById(uuid);
      menu.scrollTop = 0;

      onBlur && onBlur();
    }

    setParentState((st) => ({
      ...st,
      dropdownVisible: visible,
    }));
  };

  return (
    <>
      {title && <CustomLabel title={title} required={required} />}
      <Dropdown
        disabled={disabled}
        trigger={["click"]}
        className="multi-select-dropdown"
        visible={dropdownVisible}
        getPopupContainer={(trigger) => trigger.parentNode}
        onVisibleChange={onVisibleChange}
        overlay={overlay}
      >
        <div
          data-testid={id}
          className={`multi-select ${
            disabled ? "disabled" : ""
          } ${customClass}`}
          style={style}
        >
          {children}
        </div>
      </Dropdown>
    </>
  );
};

export default CustomDropdown;
